import MyDLD from "@my-dld/screens/MyDLD";

export default MyDLD;